import * as ng from 'angular';

import {
    PageHeaderData
} from '../../../atomic-components/organisms/page-header-panel/page-header-panel';

export class TemplateRecordContentChangeController {
    public static $inject: string[] = ['$translate'];

    public pageHeaderData: PageHeaderData;
    public zones: any[];

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit = () => {
        this.pageHeaderData = {
            backwardLink: 'dns.dashboard',
            backwardText: this.$translate.instant('TR_100119-528437_TR'),
            panelHeaderRoute: '',
            panelIcon: 'location-arrow',
            panelTitle: this.$translate.instant('TR_100119-5cfe42_TR')
        };
    };
}

export class TemplateRecordContentChangeComponent implements ng.IComponentOptions {
    public bindings = {
        zones: '<'
    };
    public template = require('./content-change-template.html');
    public controller = TemplateRecordContentChangeController;
}
